import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { registerLicense } from "@syncfusion/ej2-base";
import axiosApiInstance from "../../api/axiosApiClient";
import { getAccessToken } from "../../services/localStorageService";
import { initAppInsights } from "../../utils/AppInsights";
const ConfigContext = createContext({ config: {}, loadConfig: async () => {} });
export const useConfig = () => useContext(ConfigContext);
let initialized = false; // make sure the SDKs are set up only once per page load
function initClientSdks(data) {
  if (initialized) return;
  if (data.REACT_APP_SYNC_FUSION_LICENSE_KEY) {
    registerLicense(data.REACT_APP_SYNC_FUSION_LICENSE_KEY);
  }
  if (data.REACT_APP_APPINSIGHTS_CONNECTIONSTRING) {
    initAppInsights(data.REACT_APP_APPINSIGHTS_CONNECTIONSTRING);
  }
  initialized = true;
}
export function ConfigProvider({ children }) {
  const [config, setConfig] = useState({});
  // Not logged in -> nothing to wait for. Logged in (page refresh) -> wait for the config.
  const [ready, setReady] = useState(!getAccessToken());
  const loadConfig = useCallback(async () => {
    if (!getAccessToken()) return;
    try {
      const res = await axiosApiInstance.get(
        `${process.env.REACT_APP_AUTHAPI_URL}config/GetClientConfig`
      );
      initClientSdks(res.data); // before setConfig, so it runs before components re-render
      setConfig(res.data);
    } catch (err) {
      console.error("Failed to load client config", err);
    } finally {
      setReady(true);
    }
  }, []);
  useEffect(() => {
    loadConfig();
  }, [loadConfig]);
  if (!ready) return null; // or your <Spinner />
  return (
    <ConfigContext.Provider value={{ config, loadConfig }}>
      {children}
    </ConfigContext.Provider>
  );
}